import { render } from "./ReturnOrderCreateAndEditComponent.vue?vue&type=template&id=c0800b72"
import script from "./ReturnOrderCreateAndEditComponent.vue?vue&type=script&lang=js"
export * from "./ReturnOrderCreateAndEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/returnOrders/ReturnOrderCreateAndEditComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0800b72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0800b72', __exports__)) {
    api.reload('c0800b72', __exports__)
  }
  
  module.hot.accept("./ReturnOrderCreateAndEditComponent.vue?vue&type=template&id=c0800b72", () => {
    api.rerender('c0800b72', render)
  })

}


export default __exports__